<template>
  <div>
    <!-- <Hero /> -->
    <HeroTemporario />
    <Segmentos />
    <!-- <Chamada src="/chamadas/1600x400-1.jpg" /> -->
    <Vagas />
    <!-- Mural de Atividades Oculto (Pronto para ser ativado novamente se necessário)
    <br />
    <h1><span style="font-size:30px;">Mural de Atividades</span></h1>
    <Ead /> -->
    <Razoes />
    <Sobre />
  </div>
</template>

<script>
// import Hero from "../components/Hero";
import HeroTemporario from "../components/HeroTemporario";
import Razoes from "../components/Razoes";
import Segmentos from "../components/Segmentos";
import Sobre from "../components/Sobre";
import Vagas from "../components/matricula/Vagas";
// import Ead from "../components/ead/Index";
// import Chamada from "../components/chamada/Index";

export default {
  data: () => ({
    destaques: [
      { title1: "Educação", title2: "Infantil", link: "#" },
      { title1: "Ensino", title2: "Fundamental I", link: "#" },
      { title1: "Ensino", title2: "Fundamental II", link: "#" }
    ]
  }),
  components: {
    // Hero,
    HeroTemporario,
    // Chamada,
    Razoes,
    Segmentos,
    Sobre,
    Vagas
    // Ead
  }
};
</script>

<style lang="scss"></style>
